import React, { useState, useEffect } from "react";
import api from "@api";

export function useSystemCategorySelect(
  formValue: number,
  businessUnitId?: number,
  hasRestrictionToViewAll?: boolean
) {
  // hasRestrictionToViewAll is set if the system category needs business unit to show data.
  const [selectedCategory, setSelectedCategory] = useState(0);
  const [categories, setCategories] = useState([]);
  const [isFetchingCategories, setFetchingCategories] = useState(false);
  useEffect(() => {
    if (hasRestrictionToViewAll) {
      if (businessUnitId) {
        getAllCategoriesByBusinessUnit(businessUnitId);
      } else {
        let cats: any = [
          {
            label: "No selection",
            value: 0,
          },
        ];
        setCategories(cats);
      }
    } else {
      getAllCategories();
    }
  }, [businessUnitId]);

  function getAllCategories() {
    setFetchingCategories(true);
    api.category
      .getCategories()
      .then((response) => {
        console.log(response);
        let cats: any = [];
        response.systemCategories.forEach((d: any) => {
          cats = [
            ...cats,
            {
              label: d.name,
              value: d.id,
            },
          ];
        });
        cats = cats.sort((a: any, b: any) => a.label.localeCompare(b.label));
        cats = [
          {
            label: "No selection",
            value: 0,
          },
          ...cats,
        ];
        setCategories(cats);
      })
      .catch((error) => {
        console.log(error);
      })
      .then(() => {
        setFetchingCategories(false);
      });
  }

  function getAllCategoriesByBusinessUnit(businessUnit: number) {
    setFetchingCategories(true);
    api.category
      .getCategoriesByBusinessUnit(businessUnit)
      .then((response) => {
        console.log(response);
        let cats: any = [];
        response.systemCategories.forEach((d: any) => {
          cats = [
            ...cats,
            {
              label: d.name,
              value: d.id,
            },
          ];
        });
        cats = cats.sort((a: any, b: any) => a.label.localeCompare(b.label));
        cats = [
          {
            label: "No selection",
            value: 0,
          },
          ...cats,
        ];
        setCategories(cats);
      })
      .catch((error) => {
        console.log(error);
      })
      .then(() => {
        setFetchingCategories(false);
      });
  }

  useEffect(() => {
    if (categories.length !== 0) {
      if (formValue) {
        setSelectedCategory(formValue);
      }
    }
    return () => {
      setSelectedCategory(0);
    };
  }, [categories]);

  const handleCategoryChange = (event: any) => {
    setSelectedCategory(event.target.value);
  };

  return {
    categories,
    isFetchingCategories,
    selectedCategory,
    setSelectedCategory,
    handleCategoryChange,
  };
}
